import { Uuid } from "@/domains/global/identifiers";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SpaceAccountFeatureFlagsModelData } from "@/store/feature-flags/types";

export class SpaceAccountFeatureFlagsModel extends BaseSyncModel<SpaceAccountFeatureFlagsModelData> {
  public modelKind = SyncModelKind.SpaceAccountFeatureFlagsConfig;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<SpaceAccountFeatureFlagsModelData> } & WithAppStore) {
    super({ id, data, store });
  }

  get ownedBySpaceAccountId() {
    return this.modelData.owned_by_space_account_id;
  }

  get flags() {
    return this.modelData.flags;
  }
}
